import dayjs from "dayjs"
import relativeTimePlugin from "dayjs/plugin/relativeTime"

dayjs.extend(relativeTimePlugin)

/** "3 minutes ago". Returns an empty string for a missing date rather than
 *  "Invalid Date", which is the version users report as a bug. */
export function relativeTime(value) {
  if (!value) return ""
  const d = dayjs(value)
  return d.isValid() ? d.fromNow() : ""
}

export function formatDate(value, format = "MMM D, YYYY") {
  if (!value) return "—"
  const d = dayjs(value)
  return d.isValid() ? d.format(format) : "—"
}

export function formatDateTime(value) {
  return formatDate(value, "MMM D, YYYY · HH:mm")
}

/** Initials for an avatar, from a name or an email. */
export function initialsOf(nameOrEmail) {
  const source = String(nameOrEmail || "").trim()
  if (!source) return "?"
  const parts = source.includes("@") ? [source.split("@")[0]] : source.split(/\s+/)
  return parts
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join("")
}

/** A stable colour per person, so the same user is the same colour everywhere. */
export function avatarColor(seed) {
  /* Six tints, each dark enough to carry the white initials over it: the
     lightest of them, the green, measured 3.99:1 and is now 4.75:1. */
  const palette = ["#46811f", "#2f6fd0", "#b5541f", "#7a3fb0", "#0f7d6e", "#b03c5a"]
  const text = String(seed || "")
  let hash = 0
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) % 997
  return palette[hash % palette.length]
}

export function titleCase(value) {
  return String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

/**
 * Is this due date in the past?
 *
 * Compares whole days, not instants. A `due_date` is a calendar day — the server
 * sends `2026-09-21` — and `new Date("2026-09-21") < new Date()` is true from
 * one minute past midnight UTC, so the naive comparison marks work overdue on
 * the morning it is actually due.
 */
export function isOverdue(value) {
  if (!value) return false
  const d = dayjs(value)
  return d.isValid() && d.startOf("day").isBefore(dayjs().startOf("day"))
}
